import React, { useContext } from "react";
import loadable from "@loadable/component";
import { Column } from "@vp/swan";
import { ProductBuilderSelection } from "../../../../types/ProductBuilderTypes";
const Test2Buttons = loadable(() => import("./Test2Buttons"));

import "../../styles/Selector.scss";
import { ProductOptionsTranslations } from "@vp/product-options-ui";
import { PageStaticDataContext } from "../../../../contexts/PageStaticDataContextProvider";

interface SelectorProps {
  builderSelection: ProductBuilderSelection;
  selectorIndex: number;
  disabled: boolean;
  removePadding: boolean;
  onChange: (value: string | null) => void;
}

export const Test2Selectors = (props: SelectorProps) => {
  const { builderSelection: selection, selectorIndex, disabled, onChange } = props;
  const selectionStyle = selection?.selectionStyle;
  const { locale } = useContext(PageStaticDataContext);

  const showIncompatibleValue = selectorIndex === 0;

  return (
    <ProductOptionsTranslations locale={locale}>
      <Column
        span={selectionStyle === "Text box" ? 6 : 12}
        spanXs={selectionStyle === "Text box" ? 6 : 12}
        className={`selector-column pdp-test-2`}
      >
        <Test2Buttons
          selectionData={selection}
          showIncompatibleValues={showIncompatibleValue}
          onChange={onChange}
          disabled={disabled}
          selectorIndex={selectorIndex}
        />
      </Column>
    </ProductOptionsTranslations>
  );
};
